if (!customElements.get('tzn-legal-guarantee')) {
  customElements.define('tzn-legal-guarantee', class extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-guarantee-open]');
      if (!dialog || !opener || typeof dialog.showModal !== 'function') return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', dialog.id);
      opener.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }, options);
      this.querySelector('[data-guarantee-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
